import React from 'react';
import { Link } from 'react-router-dom';
import './links.css';

const Links = ({ text, style, path, target }) => {
  // Check if the path starts with "http://" or "https://"
  const isExternalLink = path.startsWith('http://') || path.startsWith('https://');

  // Render a regular Link if it's an internal link, otherwise render an anchor tag
  if (!isExternalLink) {
    return (
      <Link to={path} className='links-component' style={style}>
        {text}
      </Link>
    );
  } else {
    return (
      <a href={path} className='links-component' style={style} target={target} rel='noopener noreferrer'>
        {text}
      </a>
    );
  }
};

export default Links;
